import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import {
  DeleteVendorCitySlice,
  GetVendorCitySlice,
  UpdateVendorCitySlice,
} from "../../../redux/features/VendorCityManagementSlice";
import { Loader } from "../../../common/Loader/Loader";
import useParamsFormat from "../../../common/Params Values format/ParamsFormat";
import Pagination from "../../../common/pagination/PaginationCustom";

const VendorCitiesList = () => {
  const dispatch = useDispatch();
  const [cityData, setCityData] = useState([]);
  const [dataForHold, setDataForHold] = useState();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({ search: "" });

  const { createDataSetParams } = useParamsFormat();

  const { loading, AddVendorCity, UpdatedVendorCity, DeletedVendorCity } = useSelector(
    (state) => state.VendorCityManagement
  );

  const fetchList = () => {
    dispatch(GetVendorCitySlice(createDataSetParams(getSearch))).then((res) => {
      setCityData(res?.payload?.data?.cities);
      setPagination(res?.payload?.data?.pagination);
    });
  };

  useEffect(() => {
    fetchList();
  }, [AddVendorCity, UpdatedVendorCity, DeletedVendorCity]);

  const handleSearch = (e) => {
    setGetSearch({ search: e.target.value });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchList();
    }, 300);
    return () => clearTimeout(timer);
  }, [getSearch.search]);

  const handlePagesIncrease = () => {
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);
  };

  const handleDelete = () => {
    dispatch(DeleteVendorCitySlice(dataForHold)).then(() => {
      fetchList();
    });
  };

  const handleToggleStatus = (item) => {
    dispatch(
      UpdateVendorCitySlice({
        id: item?._id,
        data: { isActive: !item?.isActive },
      })
    ).then(() => {
      fetchList();
    });
  };

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h2>Vendor City Management</h2>
            <Link
              to={"CreateVendorCity"}
              data-toggle="modal"
              data-target="#CreateVendorCity"
              className="Button"
            >
              Add City
            </Link>
          </div>
          <div className="Small-Wrapper">
            <div className="Filter justify-content-between">
              <div className="FilterLeft">
                <div className="form-group">
                  <label>Search</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search city or state"
                    value={getSearch.search}
                    onChange={handleSearch}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="TableList">
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>City Name</th>
                  <th>State</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <Loader />
                ) : Array.isArray(cityData) && cityData?.length > 0 ? (
                  cityData?.map((item, index) => {
                    return (
                      <tr key={item?._id || index}>
                        <td>{index + 1}</td>
                        <td>{item?.cityName}</td>
                        <td>{item?.state}</td>
                        <td>{item?.createdAt?.substring(0, 10)}</td>
                        <td>
                          <span className={item?.isActive ? "Green" : "Red"}>
                            {item?.isActive ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <div className="Actions">
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={item?.isActive}
                                onChange={() => handleToggleStatus(item)}
                              />
                              <span className="slider" />
                            </label>
                          </div>
                        </td>
                        <td>
                          <div className="Actions">
                            <Link
                              to={"UpdateVendorCity"}
                              className="Green"
                              data-toggle="modal"
                              data-target="#UpdateVendorCity"
                              state={item}
                            >
                              <i className="fa fa-pencil" />
                            </Link>
                            <a
                              className="Red"
                              data-toggle="modal"
                              data-target="#DeleteModal"
                              onClick={() => setDataForHold(item?._id)}
                            >
                              <i className="fa fa-trash" />
                            </a>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={7}>There is no City</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            <Pagination
              arr={arr}
              page={page}
              handlePagesIncrease={handlePagesIncrease}
              FetchDataOnPages={FetchDataOnPages}
              handlePagesDecrease={handlePagesDecrease}
            />
          </div>
        </div>
      </div>
      <div className="ModalBox">
        <div id="DeleteModal" className="modal fade" style={{ display: "none" }} aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a href="javascript:void(0);" className="CloseModal" data-dismiss="modal">
                    ×
                  </a>
                  <h3>Delete</h3>
                  <p>Are you sure you want to Delete this City?</p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a href="javascript:void(0);" data-dismiss="modal" onClick={handleDelete}>
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Outlet />
      </div>
    </>
  );
};

export default VendorCitiesList;
